/*
 *@Description:字典工具库
 *@Author: zgguc
 *@Date: 2019-04-21 22:58:13
 */
import utils from '$utils'
const lang = 'zh'
const DIC = {
  Prefix(num, n = 3) {
    return (Array(n).join(0) + num).slice(-n)
  },
  /**
   *@name:find
   *@param dicName 字典名称
   *@description:根据字典名称获取字典数据
   *@return:
   *@author: zgguc
   *@date: 2019-04-23
   */
  find(dicName, ops = {}, isValueParseInt = true) {
    const dicForKey = []
    const dics = utils.Cache.get('SYS_DIC')
    // 父子级联选项
    if (ops.relation) {
      dicName = dicName + this.Prefix(ops.relation, ops.reNum || 3)
    }

    if (!dics) {
      return
    }

    // 字典项遍历
    dics.map((item) => {
      if (item.enumType === dicName) {
        // 字段选项过滤器
        const filter = ops.filter

        const option = {
          label: '',
          value: '',
        }
        if (lang === 'zh') {
          option.label = item.label
        } else {
          option.label = item.label
        }
        // -1,0
        if (filter && Array.isArray(filter) && filter.some((val) => val == item.itemValue)) {
          return
        }
        option.value = isValueParseInt ? parseInt(item.itemValue) : item.itemValue
        dicForKey.push(option)
      }
    })
    return dicForKey
  },
  /**
   * *@name:findByValue
   * @param dicName 数据字典名称
   * @param value 数据字典的值
   * @description: 根据字典的value获取label
   * @return: 无
   * @author: zgguc
   * @date: 2019-04-23
   * @returns {*}
   */
  findByValue(dicName, value,isValueParseInt = true) {
    const options = this.find(dicName, {}, isValueParseInt)
    if (!options) {
      return
    }
    const item = _.find(options, function (o) {
      // console.log(o, _, '===o')
      return o.value === value || o.value === parseInt(value)
    })
    // console.log(item, '==item')
    if (!item) {
      return ''
    }
    return item.label
  },
  /**
   * @name:findByLabel
   * @param dicName 数据字典名称
   * @param label 数据字典的标签
   * @description: 根据字典的label获取value
   * @return: 无
   * @author: zgguc
   * @date: 2019-04-23
   * @returns {*}
   */
  findByLabel(dicName, label,isValueParseInt = true) {
    const options = this.find(dicName, {}, isValueParseInt)
    if (!options) {
      return
    }
    const item = _.find(options, function (o) {
      return o.label === label
    })
    if (!item) {
      return ''
    }
    return item.value
  },
  linkStr(dicName, str,isValueParseInt = true) {
    const likes = []
    const options = this.find(dicName, {}, isValueParseInt)
    if (!options) {
      return
    }
    _.map(options, (item) => {
      if (item.value.toString().match(str)) {
        likes.push(item)
      }
    })
    return likes
  },
}

export default DIC